export default {
'批量添加完成':'批量添加完成',
'教师导入模板':'教师导入模板',
'学生导入模板':'学生导入模板',
'导入中请不要退出当前页面。':'导入中请不要退出当前页面。',
'人脸导入{name}':'人脸导入{name}',
'手机号':'手机号',
'姓名':'姓名',
'工号':'工号',
'只能导入格式为':'只能导入格式为png、jpg、jpeg的文件，文件命名格式为（手机号 或 姓名 或 工号）,单张人脸大小不超过10M',
'导入成功数量：':'导入成功数量：',
'导入失败数量：':'导入失败数量：',
'点击导入':'点击导入',
'导入失败人员列表':'导入失败人员列表',
'失败原因':'失败原因',
'表格数据':'表格数据',
'正在准备图片':'正在准备图片',
'压缩图片中':'压缩图片中',
'文件超过10MB':'文件超过10MB',
'图片损坏无法打开':'图片损坏无法打开',
'文件格式错误':'文件格式错误',
'数据导入成功，但有失败数据。请点击':'数据导入成功，但有失败数据。请点击',
'教师信息':'教师信息',
'编辑教职工':'编辑教职工',
'新增教职工':'新增教职工',
'请输入用户名称':'请输入用户名称',
'请输入登录账号':'请输入登录账号',
'登录账号已存在，请重新输入':'登录账号已存在，请重新输入',
'登录账号长度最多为20位':'登录账号长度最多为20位',
'登录账号长度至少为6位':'登录账号长度至少为6位',
'请输入有效的账号':'请输入有效的账号',
'请输入登录密码':'请输入登录密码',
'账号密码格式仅支持大小写字母、数字及特殊符号':'账号密码格式仅支持大小写字母、数字及特殊符号',
'登录密码长度至少为8位':'登录密码长度至少为8位',
'请选择角色':'请选择角色',
'请输入手机号':'请输入手机号',
'请输入正确的手机号':'请输入正确的手机号',
'请选择性别':'请选择性别',
'请输入姓名':'请输入姓名',
'正在加载数据，请稍后':'正在加载数据，请稍后...',
'用户信息':'用户信息',
'登录账号':'登录账号',
'请输入6':'请输入6-20位纯数字/字母或者数字+字母组合',
'登录密码':'登录密码',
'重置密码':'重置密码',
'角色':'角色',
'执教班级':'执教班级',
'请选择执教班级':'请选择执教班级',
'请输入工号':'请输入工号',
'ID卡号':'ID卡号',
'ID卡号仅支持数字':'ID卡号仅支持数字',
'请填写ID卡号':'请填写ID卡号',
'账户信息':'账户信息',
'账户信息是该账户下所有用户的公用信息':'账户信息是该账户下所有用户的公用信息',
'去认证':'去认证',
'证件类型':'证件类型',
'请选择证件类型':'请选择证件类型',
'证件号':'证件号',
'请输入证件号':'请输入证件号',
'人脸照片':'人脸照片',
'认证手机号':'认证手机号',
'教职工管理':'教职工管理',
'请输入名称':'请输入名称/账号',
'批量新增教师':'批量新增教师',
'批量导出教师':'批量导出教师',
'批量添加照片':'批量添加照片',
'批量删除教师':'批量删除教师',
'新增教师':'新增教师',
'批量导入教师人脸':'批量导入教师人脸',
'是否删除此用户？':'是否删除此用户？',
'删除教师':'删除教师',
'请选择教师':'请选择教师',
'导入中请不要退出当前页面。':'导入中请不要退出当前页面。',
'学籍号人脸导入':'学籍号人脸导入',
'姓名人脸导入':'姓名人脸导入',
'只能导入格式为学籍号':'只能导入格式为png、jpg、jpeg的文件，文件命名格式为（学籍号 或 姓名）,单张人脸大小不超过10M',
'学生信息':'学生信息',
'编辑学生':'编辑学生',
'新增学生':'新增学生',
'请选择班级':'请选择班级',
'学籍号已注册':'学籍号已注册',
'数据保存成功':'数据保存成功',
'请填写家长姓名':'请填写家长姓名',
'请填写家长性别':'请填写家长性别',
'请填写家长关系':'请填写家长关系',
'请填写家长联系方式':'请填写家长联系方式',
'家长{num}的联系方式格式不正确，请重新填写':'家长{num}的联系方式格式不正确，请重新填写',
'家长姓名':'家长姓名',
'家长关系':'家长关系',
'联系方式':'联系方式',
'家长手机号':'家长手机号',
'学号':'学号',
'请输入学号':'请输入学号',
'请输入学籍号':'请输入学籍号',
'民族':'民族',
'请选择民族':'请选择民族',
'家长信息':'家长信息',
'新增家长':'新增家长',
'请输入家长姓名':'请输入家长姓名',
'请输入家长手机号':'请输入家长手机号',
'请输入正确的家长手机号':'请输入正确的家长手机号',
'该学生已存在相同登录账号的家长':'该学生已存在相同登录账号的家长',
'该学生已存在相同手机的家长':'该学生已存在相同手机的家长',
'为空则系统自动生成':'为空则系统自动生成',
'确认删除吗':'确认删除吗',
'用户列表':'用户列表',
'请输入姓名或账号':'请输入姓名或账号',
'批量删除':'批量删除',
'人脸批量导入':'人脸批量导入',
'批量导入人脸照片':'批量导入人脸照片',
'关闭后，将中止上传':'关闭后，将中止上传',
'已成功的照片不受影响':'已成功的照片不受影响',
'删除学生':'删除学生',
'请选择学生':'请选择学生',
'家长信息':'家长信息',
'编辑家长':'编辑家长',
'新增家长':'新增家长',
'子女信息不能为空':'子女信息不能为空',
'学生姓名':'学生姓名',
'保存用户成功':'保存用户成功',
'子女信息':'子女信息',
'编辑用户':'编辑用户',
'新增用户':'新增用户',
'组织结构':'组织结构',
'请选择组织结构':'请选择组织结构',
'请选择院系':'请选择院系',
'学籍号已注册':'学籍号已注册',
'请输入名称与账号':'请输入名称/账号/手机号/学籍号',
'批量导入学生':'批量导入学生',
'批量导出学生':'批量导出学生',
'批量导出家长':'批量导出家长',
'批量删除家长':'批量删除家长',
'是否停用此用户？':'是否停用此用户？',
'删除家长':'删除家长',
'请选择家长':'请选择家长',
'获取验证码':'获取验证码',
'请输入手机验证码':'请输入手机验证码',
'手机验证码':'手机验证码',
'认证':'认证',
'手机号不能为空！':'手机号不能为空！',
'手机验证码不能为空！':'手机验证码不能为空！',
'账号信息':'账号信息',
'请输入姓名，不超过20个字':'请输入姓名，不超过20个字',
'编辑角色账号信息':'编辑角色账号信息',
'角色账号信息更新成功':'角色账号信息更新成功',
'账户信息修改将会影响该账户下所有用户的共有信息。':'账户信息修改将会影响该账户下所有用户的共有信息。',
'编辑账户信息':'编辑账户信息',
'账户信息更新成功':'账户信息更新成功',
'用户反馈':'用户反馈',
'登录密码不能为空':'登录密码不能为空',
'进入':'进入',

//25-7-31
'市民管理':'市民管理',
'注册场所':'注册场所',
'注册时间':'注册时间',
'批量新增市民':'批量新增市民',
'批量导出市民':'批量导出市民',
'批量删除市民':'批量删除市民',
'新增市民':'新增市民',
'编辑市民':'编辑市民',
//25-8-1
'操作成功':'操作成功',
'用户名称':'用户名称',
'登录账号':'登录账号',
'注册来源':'注册来源',
'获取成功':'获取成功',
'市民信息':'市民信息',
'生日':'生日',
'家庭住址':'家庭住址',
'学生':'学生',
'游客':'游客',
}
